
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LocalizationMethods extends Vue {
    get currentLocalizationKey() {
        return this.$store.getters['Localization/getLocalizationKey'];
    }

    get currentLocalizationObject() {
        return this.$store.getters['Localization/getCurrentLanguageObject'];
    }
}
